import React from 'react';
import { Tag } from 'antd';
import { formatCurrencyWithConversion } from "../../../../utils/currencyUtils";

/**
 * Cash columns configuration for the CashAllocation component
 * @param {Object} allocationStatus - The current allocation status
 * @returns {Array} Array of column configurations for the cash table
 */
const getCashColumns = (allocationStatus) => [
  { title: 'Number', dataIndex: 'number', key: 'number' },
  { 
    title: 'Issue Date', 
    dataIndex: 'issue_date', 
    key: 'issue_date',
    render: date => date ? new Date(date).toLocaleDateString() : ''
  },
  { title: 'Reference', dataIndex: 'reference', key: 'reference' },
  { title: 'Type', dataIndex: 'cash_type', key: 'cash_type' },
  { 
    title: 'Amount', 
    dataIndex: 'total_amount', 
    key: 'total_amount',
    render: (amount, record) => {
      const currency = record?.currency || record?.originalData?.currency || "$";
      return formatCurrencyWithConversion(amount || 0, currency);
    }
  },
  {
    title: 'Allocated',
    key: 'allocated',
    render: (_, record) => {
      if (allocationStatus) {
        const currency = record?.currency || record?.originalData?.currency || "$";
        return <span>{formatCurrencyWithConversion(allocationStatus.totalAllocated || 0, currency)} ({allocationStatus.percentAllocated.toFixed(2)}%)</span>;
      }
      return '0.00 (0%)';
    }
  },
  {
    title: 'Unallocated Amount',
    key: 'unallocated',
    render: (record) => {
      const currency = record?.currency || record?.originalData?.currency || "$";
      if (allocationStatus && record.total_amount) {
        const totalAmount = parseFloat(record.total_amount);
        const unallocatedAmount = totalAmount - allocationStatus.totalAllocated;
        return formatCurrencyWithConversion(unallocatedAmount, currency);
      }
      return formatCurrencyWithConversion(record.total_amount || 0, currency);
    }
  },
  {
    title: 'Allocation Status',
    key: 'allocation_status',
    render: () => {
      if (allocationStatus) {
        return <Tag color={allocationStatus.color}>{allocationStatus.label}</Tag>;
      }
      return <Tag color="default">Unallocated</Tag>;
    }
  },
];

export default getCashColumns;
